import { buildFamsPageMessages } from 'config/fams-menu';

export default {
  'pages.layouts.userLayout.title': 'Welcome',
  'pages.getCaptchaSecondText': 'sec(s) left',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  ...buildFamsPageMessages('en-US'),
};
